import { ConfidentialDataAccessOption } from './ConfidentialDataAccessCell.types';

export const CONFIDENTIAL_DATA_ACCESS_OPTIONS: ConfidentialDataAccessOption[] = ['MONITORED', 'AUTHORIZED'];
